export type SiteConfig = typeof siteConfig;

export const siteConfig = {
    name: "Szeretet",
    description: "Szeress engem!!!",
    navItems: [
        {
            label: "Fő oldal",
            href: "/dashboard",
        },
        {
            label: "Kérdésbank",
            href: "/questions",
        },
        {
            label: "Vizsgak",
            href: "/exams",
        },
        {
            label: "Felhasznalok kezelése",
            href: "/manage_users",
        },
        {
            label: "Eredmények",
            href: "/result",
        }



    ],
    navMenuItems: [
        {
            label: "Profile",
            href: "/profile",
        },
        {
            label: "Dashboard",
            href: "/dashboard",
        },
        {
            label: "Projects",
            href: "/projects",
        },
        {
            label: "Team",
            href: "/team",
        },
        {
            label: "Calendar",
            href: "/calendar",
        },
        {
            label: "Settings",
            href: "/settings",
        },
        {
            label: "Help & Feedback",
            href: "/help-feedback",
        },
        {
            label: "Logout",
            href: "/logout",
        },
    ],

};
